import { render } from "./flashPlayer.vue?vue&type=template&id=2b2be6b7&scoped=true"
import script from "./flashPlayer.vue?vue&type=script&lang=js"
export * from "./flashPlayer.vue?vue&type=script&lang=js"

import "./flashPlayer.vue?vue&type=style&index=0&id=2b2be6b7&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2be6b7"]])

export default __exports__